<p-dataView #dv [value]="listLinkedFile" layout="list">

  <ng-template let-listquote pTemplate="list">
      <div class="flex justify-content-between align-items-center mt-3">
          <div>
              <p-button label="Add" class="p-button-outlined ml-2" icon="pi pi-save" size="small" (click)="openLinkedFiles()"></p-button>
              <p-button *ngIf="selected?.length === 1" label="Update" class="p-button-outlined ml-2" icon="pi pi-user-edit" severity="secondary" size="small" (click)="updateLinkedFile(selected[0])"> </p-button>
              <p-button *ngIf="selected && selected.length > 0" label="Delete" class="p-button-outlined ml-2" icon="pi pi-trash" severity="danger" size="small" (click)="deleteLinkedFile()"> </p-button>
              <!-- <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger" size="small" (click)="cancel(linkedFiledForm.value)"> </p-button> -->
          </div>
      </div>

      <p-table #dt1 [value]="listLinkedFile" [scrollable]="true" scrollHeight="613px" styleClass="p-datatable-striped" responsiveLayout="scroll"
          class="w-full m-5" styleClass="p-datatable-sm" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10 ,15, 20]"
          [(selection)]="selected" [rowHover]="true" (onPage)="loadList($event)">

          <ng-template pTemplate="header">
              <tr>
                  <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                  <th>Linked File</th>
                  <th>View</th>
                  <!-- <th>Description</th> -->
                  <th>Type</th>
                  <th>Linked By</th>
                  <th>Linked On</th>
              </tr>
          </ng-template>

          <ng-template pTemplate="body" let-linkFile>
              <tr>
                  <td><p-tableCheckbox [value]="linkFile"></p-tableCheckbox></td>
                  <td class="text-blue-500 underline" style="cursor: pointer;" (click)="updateLinkedFile(linkFile)">{{ linkFile.linkedId }}</td>
                  <td><p-button icon="pi pi-eye" (click)="viewDocument(linkFile)" size="small" class="p-button-rounded p-button-outlined"></p-button></td>
                  <!-- <td>{{ linkFile.description}}</td> -->
                  <td>{{ linkFile.type }}</td>
                  <td>{{ linkFile.linkedBy }}</td>
                  <td>{{ linkFile.date | date: 'dd/MM/yyyy' }}</td>
              </tr>
          </ng-template>

      </p-table>
  </ng-template>

</p-dataView>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
